export class DataLayerProduct {
    id = "";
    brand = "Pacífico";
    category = "Seguro de hogar";
    name = "Hogar";
}

export class DataLayerProductList extends DataLayerProduct {
    list = "Lista de hogar";
}
